import { HOUR_IN_MS, MINUTE_IN_MS } from "@tradingApp/constants";

interface Params {
  expiresAt: number;
}

export function countdown(params: Params): string {
  const { expiresAt } = params;
  const difference = expiresAt - Date.now();

  if (difference > 0) {
    const timeLeft = [];
    const days = Math.floor(difference / (24 * 60 * 60 * 1000));
    const hours = Math.floor((difference / HOUR_IN_MS) % 24);
    const minutes = Math.floor((difference / MINUTE_IN_MS) % 60);

    if (days) {
      timeLeft.push(`${days}d`);
    }

    if (hours) {
      timeLeft.push(`${hours}h`);
    }

    if (minutes && !days) {
      timeLeft.push(`${minutes}m`);
    }

    return `${timeLeft.join(":")} left`;
  }

  return "Finished";
}
